import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  useMediaQuery,
  Grid,
  Chip,
  Icon,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';

import {
  getRoleList,
  getRoleDescription,
  getRoleFeatures,
} from '../../../utils/rolesHelper';
import styles from './styles';

const useStyles = makeStyles(styles);

export const AboutUserRolesModalComponent = (props) => {
  const fullScreen = useMediaQuery(useTheme().breakpoints.down('sm'));
  const {
    open,
    onClose,
  } = props;
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      aria-labelledby="user-role-info"
      aria-describedby="user-role-info"
      id="user-role-info-dialog"
      className={classes.root}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="remove-user-title">Pingum Roles</DialogTitle>
      <DialogContent>
        <Grid container className={classes.demo} justify="center" alignItems="center" spacing={4}>
          <Grid xs={12} sm={6} item className={classes.userTypeDescriptionGridItem}>
            <Chip
              icon={<Icon>face</Icon>}
              label="Active Users"
              className={classes.userChip}
              color="secondary"
            />
            <div>
              <Typography color="inherit" className={classes.userDescription}>
                This user performs operations and creates workflows when
                needed. They manage those workflows through statuses,
                comments, and other mechanisms.
              </Typography>
            </div>
          </Grid>
          <Grid xs={12} sm={6} item className={classes.userTypeDescriptionGridItem}>
            <Chip
              icon={<Icon>face</Icon>}
              label="Passive Users"
              className={classes.userChip}
              color="default"
            />
            <div>
              <Typography color="inherit" className={classes.userDescription}>
                This user needs to be notified of workflows in your organization.
                They will only have access to view and receive notifications
                for workflows you have assigned to them (Read Only).
              </Typography>
            </div>
          </Grid>
        </Grid>
        {getRoleList().map((role) => (
          <Accordion
            key={role}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography className={classes.heading}>
                {role}
              </Typography>
              <Typography
                className={classes.secondaryHeading}
                component="div"
              >
                {getRoleDescription(role)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography component="div">
                {getRoleFeatures(role).join(', ')}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          id="close-role-info-dialog"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AboutUserRolesModalComponent.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};
AboutUserRolesModalComponent.defaultProps = {
  open: false,
  onClose: () => {},
};

export default AboutUserRolesModalComponent;
